
import { defineComponent } from "vue";

import defaultImage from "@/assets/images/user.png";
import onboarding from "@/assets/images/icon-onboarding.png";
import XarcadeAccountService from "@/services/XarcadeAccountService";
import OnboardingChecklistService from "@/services/OnboardingChecklistService";
import User from "@/_models/User";
import ResponseData from "@/_models/ResponseData";
import store from '@/store/index';
import { Helper } from "@/utils/Helper";
import 'mosha-vue-toastify/dist/style.css';

export default defineComponent({
  data: function () {
    return {
      image: defaultImage,
      fileName: "",
      imageFile: "",
      onboarding: onboarding,
      url: this.$route.query.page,
      userData: store.getters["auth/user"] ?? "",
      jwtToken: store.getters["auth/jwtToken"] ?? "",
      user: {
        username: "",
        websiteURL: "",
        introduction: "",
      } as User,
      company: "",
      currentCompany: "",
      hasChanged: false,
      valueChanged: false,
      emptyField: false,
      isDisplayUploadUserImageLabel: false,
    };
  },
  methods: {
    pickFile() {
      let input = this.$refs.fileInput;
      let file = input.files;
      this.fileName = file[0].name;
      this.imageFile = file;

      if (file[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.image = e.target.result;
        };
        reader.readAsDataURL(file[0]);
        this.$emit("input", file[0]);
      }
    },

    revertUserImage() {
      this.imageFile = null;
      this.image = null;
    },

    updateUserImage() {
      let formData = new FormData();

      if (this.imageFile !== "") {
        formData.append("ProfileStream", this.imageFile[0]);

        XarcadeAccountService.updateUserDetails(this.userData.userId, this.jwtToken, formData)
          .then((response: ResponseData) => {
            XarcadeAccountService.getXarcadeUser(this.userData.userId)
              .then( async(getResponse: ResponseData) => {
                this.updateOnboardingChecklist(this.userData.userId, this.jwtToken);
                this.updateOnboardingChecklist(this.userData.userId, this.jwtToken);
                let fetchedUser = getResponse.data["xarcadeUser"];
                // refetch wallet info
                const testnetCredentials = await XarcadeAccountService.getTestnetWallet( this.userData.userId, this.jwtToken);
                // mainnet
                let mainnetCredentials:any;
                if(this.enableMainnet){
                  mainnetCredentials = await XarcadeAccountService.getMainnetWallet( this.userData.userId, this.jwtToken);
                }else{
                  mainnetCredentials = '';
                }
                store.dispatch("auth/updateUser", {
                  userData: {...fetchedUser, testnetPublicAddress: testnetCredentials.data.publicAddress, testnetWalletAddress: testnetCredentials.data.walletAddress, mainnetPublicAddress: this.enableMainnet?mainnetCredentials.data.publicAddress:'', mainnetWalletAddress: this.enableMainnet?mainnetCredentials.data.walletAddress:'' },
                });
                this.userData = store.getters["auth/user"];
                this.populateUserProfile();
                localStorage.setItem("profileSetup", "1");
                this.emitter.emit('REFRESH_PROFILE_PHOTO', true);
              });
            Helper.toastSuccessHandling(response.data['message']);
            this.isDisplayUploadUserImageLabel = false;
          })
          .catch((error) => {
            Helper.endpointErrorHandling(error);
            console.log(error.response);
          });
      }
    },
    updateUserProfile() {
      let formData = new FormData();
      let user = store.getters["auth/user"];

      if (this.user.websiteURL !== user.websiteUrl) {
        if (this.user.websiteURL !== "") {
          this.hasChanged = true;
          formData.append("WebsiteUrl", this.user.websiteURL);
        } else {
          this.emptyField = true;
        }
      }

      if (this.user.introduction !== user.introduction) {
        if (this.user.introduction !== "") {
          this.hasChanged = true;
          formData.append("Introduction", this.user.introduction);
        } else {
          this.emptyField = true;
        }
      }

      if (this.company !== user.company) {
        if (this.company !== "") {
          this.hasChanged = true;
          formData.append("Company", this.company);
        } else {
          this.emptyField = true;
        }
      }

      if (this.hasChanged === true) {
        XarcadeAccountService.updateUserDetails(this.userData.userId, this.jwtToken, formData)
          .then((updateResponse: ResponseData) => {
            if (updateResponse.status === 200) {
              Helper.toastSuccessHandling(updateResponse.data['message']);
              XarcadeAccountService.getXarcadeUser(this.userData.userId)
                .then((getResponse: ResponseData) => {
                  this.updateOnboardingChecklist(this.userData.userId, this.jwtToken);
                  store.dispatch("auth/updateUser", {
                    userData: getResponse.data["xarcadeUser"],
                  });
                  localStorage.setItem("profileSetup", "1");
                  this.populateUserProfile();
                  this.userData = store.getters["auth/user"];
                  this.hasChanged = false;
                  this.valueChanged = false;
                  this.emptyField = false;
                });
            }
          })
          .catch((error) => {
            Helper.endpointErrorHandling(error);
          });
      } else {
        if (this.emptyField === true) {
          Helper.endpointErrorHandling('', 'Fields are empty!');
        } else {
          this.valueChanged = false;
          Helper.endpointErrorHandling('', 'Fields are not updated!');
        }
      }
    },

    populateUserProfile() {
      if (this.userData !== "") {
        let user = store.getters["auth/user"];

        this.user.username = user.username;
        this.user.websiteURL = user.websiteUrl;
        this.user.introduction = user.introduction;
        this.company = user.company;
        this.currentCompany = user.company;
        if(user.profilePicture){
          this.image = this.assetUrl + 'blob/users/' + user.username + '/' + user.profilePicture;
        }
      }
    },

    inputHasChanged(modelName: string, userDetails: string) {
      if (modelName !== userDetails) {
        this.valueChanged = true;
      }
    },

    updateOnboardingChecklist(userId: string, token: string) {
      OnboardingChecklistService.getOnboardingChecklist(userId, token)
        .then((response: ResponseData) => {
          OnboardingChecklistService.saveUpdatedOnboardingChecklist(response.data.items, 2, userId, token);
        })
        .catch((error) => {
          Helper.endpointErrorHandling(error);
        });
    },
  },

  mounted() {
    this.populateUserProfile();
  },

  computed: {
    assetUrl() {
      return store.getters['config/assetUrl'];
    },
    enableMainnet() {
      return store.getters['config/getEnableMainnet'];
    }
  },

  name: 'accountPublicProfileComponent',
  components: {},
});
